module.exports = __webpack_public_path__ + "static/wersel-slide-7211d8f466098995651c317daadeef7b.png";